import SaveButton from "@/components/button/save-button";
import { ProfilePageContainer } from "@/components/container/profile-page-container";
import { InlineSearchInput } from "@/components/form/inline-search-input";
import { SelectablePill } from "@/components/form/selectable-pill";
import { ListRenderer } from "@/components/list/list-renderer";
import { PageTitleComponent } from "@/components/page-title";
import { RecreatePlanAlert } from "@/features/settings/components/recreate-plan-alert";
import { useFoodAvoids } from "@/hooks/features/use-food-avoids";
import { useToast } from "@/hooks/ui/use-toast";
import { IonSkeletonText, useIonRouter } from "@ionic/react";
import { useState } from "react";

export default function SettingFoodPreferenceFoodAvoidsPage() {
  const navigation = useIonRouter();
  const [isOpen, setIsOpen] = useState(false);
  const { showSuccess } = useToast();
  const {
    foodSet,
    selectedFoods,
    setSelectedFoods,
    setFoodSet,
    handleSubmit,
    isUpdating,
    isLoading,
    sortedFoodList,
  } = useFoodAvoids(() => {
    setIsOpen(true);
  });

  const handleCancel = () => {
    setIsOpen(false);
    navigation.goBack();
  };

  const handleRecreatePlan = () => {
    setIsOpen(false);
    showSuccess("Recreate plan successful");
    navigation.goBack();
  };

  return (
    <ProfilePageContainer className="overflow-y-auto no-scrollbar pb-16">
      <PageTitleComponent
        title="Foods you don't like"
        description="Please select any foods you dislike from the list below. If a food is not listed, you may search for it."
        className="mt-2 mb-6 w-full"
      />

      <div className="w-full flex flex-col gap-8 flex-1">
        <InlineSearchInput
          label="Add"
          onSubmit={(value) => {
            if (foodSet.has(value)) {
              return;
            }
            setFoodSet((prev) => new Set(prev).add(value));
            setSelectedFoods((prev) => new Set(prev).add(value));
          }}
        />

        <ListRenderer
          items={sortedFoodList}
          isLoading={isLoading}
          emptyComponent={
            <div className="w-full flex flex-col justify-center items-center gap-8 flex-1 text-sm text-gray-500">
              No foods to avoid found
            </div>
          }
          loadingComponent={
            <div className="grid grid-cols-2 gap-4">
              {Array.from({ length: 20 }).map((_, index) => (
                <IonSkeletonText key={index} className="w-full h-10" animated />
              ))}
            </div>
          }
        >
          <div className="grid grid-cols-2 gap-4 flex-1">
            {sortedFoodList.map((food) => (
              <SelectablePill
                key={food}
                label={food}
                selected={selectedFoods.has(food)}
                onClick={() => {
                  if (selectedFoods.has(food)) {
                    setSelectedFoods((prev) => {
                      const next = new Set(prev);
                      next.delete(food);
                      return next;
                    });
                  } else {
                    setSelectedFoods((prev) => new Set(prev).add(food));
                  }
                }}
              />
            ))}
          </div>
        </ListRenderer>
        <SaveButton
          text="Save"
          position="fixed"
          onSave={handleSubmit}
          disabled={isUpdating}
        />
      </div>
      <RecreatePlanAlert
        isOpen={isOpen}
        onCancel={handleCancel}
        onConfirm={handleRecreatePlan}
      />
    </ProfilePageContainer>
  );
}
